import PropTypes from 'prop-types';
import React from 'react';
import ESpot from '@/components/layout/espots/ESpot';
import { stripHtml } from '@/utils/menuUtils';
import styles from './DesktopMenuEspot.module.scss';

const DesktopMenuEspot = ({ data, menuLevel1, onClickMenu, bottomData = false }) => {
	const htmlContent = bottomData ? data?.bottomData : data?.htmlContent;

	return data?.espotForFront ? (
		<ESpot spot={data.espotForFront} />
	) : (
		<div
			className={`${styles['desktop-menu-espot']} tu-desktop-menu-espot`}
			onClick={() => onClickMenu(menuLevel1, stripHtml(htmlContent))}
			dangerouslySetInnerHTML={{ __html: htmlContent }}
		/>
	);
};

DesktopMenuEspot.propTypes = {
	data: PropTypes.object.isRequired,
	menuLevel1: PropTypes.string.isRequired,
	onClickMenu: PropTypes.func.isRequired,
	bottomData: PropTypes.bool,
};

export default React.memo(DesktopMenuEspot);
